import { Controller } from "stimulus"

export default class extends Controller {

	static targets = [  ]

	static values = {
		uuid: String,
		parent: String,
		parentUuid: String
	}

	connect() {

	}

	confirmDelete() {
		let btnDelete = event.target.parentElement.querySelector('button[data-btn-action="delete"]');
		let btnConfirm = event.target.parentElement.querySelector('button[data-btn-action="confirm"]');
		let btnCancel = event.target.parentElement.querySelector('button[data-btn-action="cancel"]');
		btnConfirm.classList.toggle("d-none");
		btnDelete.classList.toggle("d-none");
		btnCancel.classList.toggle("d-none");
	}

	confirmDeleteCancel() {
		let btnDelete = event.target.parentElement.querySelector('button[data-btn-action="delete"]');
		let btnConfirm = event.target.parentElement.querySelector('button[data-btn-action="confirm"]');
		let btnCancel = event.target.parentElement.querySelector('button[data-btn-action="cancel"]');
		btnConfirm.classList.toggle("d-none");
		btnDelete.classList.toggle("d-none");
		btnCancel.classList.toggle("d-none");
	}

	delete() {
		let target = event.target;
		let that = this;
		let comment = event.target.closest("div.comment")

		Rails.ajax({
			url: `/${I18n.locale}/comments/${comment.dataset.parent}/${comment.dataset.parentUuid}/${comment.dataset.uuid}/delete`,
			type: "delete",
			success: function(data) {
				let div = target.closest(`div[data-uuid="${comment.dataset.uuid}"]`);
				if(div) {
					div.remove();
				}
			},
			error: function(data) {}
		});
	}

	reload() {

	}
}
